import { createSelector } from 'reselect'
import { getSecuritiesStaticDataInfoCache } from '../../securities/selectors'
import { namespace } from '.'
import { State } from './reducer'

export interface TickerSuggestion {
  ticker: string
  count: number
  rating: string | undefined
}

export const getTickerRatingState = (state: { [namespace]: State }) =>
  state[namespace]

export const getTickerRatingIsOpen = createSelector(
  [getTickerRatingState],
  (state) => state.isOpen
)

export const getTickerRatingApiCall = createSelector(
  [getTickerRatingState],
  (state) => state.apiCall
)

const emptyTickerSuggestions: TickerSuggestion[] = []

export const getTickerSuggestions = createSelector(
  [getSecuritiesStaticDataInfoCache],
  (cache) => {
    const values = Object.values(cache)
    if (values.length === 0) return emptyTickerSuggestions
    const info = new Map<
      string,
      { count: number; rating: string | undefined }
    >()
    for (const s of values) {
      if (!s.issuerSymbol) continue
      const key = s.issuerSymbol.toUpperCase()
      const existing = info.get(key)
      if (existing) {
        existing.count++
      } else {
        info.set(key, { count: 1, rating: s.sAndPRating || undefined })
      }
    }
    return Array.from(info, ([ticker, { count, rating }]) => ({
      ticker,
      count,
      rating
    })).sort((a, b) => a.ticker.localeCompare(b.ticker))
  }
)
